"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAB_TYPE_LABEL = exports.TAB_TYPE = exports.LIMIT = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'basic-tab';
exports.CHILD = 'basic-tab/basic-tab-pane';
exports.LIMIT = {
    MAX: 8
};
// 激活样式类型
exports.TAB_TYPE = {
    LINE: 0,
    CIRCLE: 1 // 圆形
};
exports.TAB_TYPE_LABEL = {
    [exports.TAB_TYPE.LINE]: '线段',
    [exports.TAB_TYPE.CIRCLE]: '圆形'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxXQUFXLENBQUM7QUFDbkIsUUFBQSxLQUFLLEdBQUcsMEJBQTBCLENBQUM7QUFFbkMsUUFBQSxLQUFLLEdBQUc7SUFDakIsR0FBRyxFQUFFLENBQUM7Q0FDVCxDQUFDO0FBRUYsU0FBUztBQUNJLFFBQUEsUUFBUSxHQUFHO0lBQ3BCLElBQUksRUFBRSxDQUFDO0lBQ1AsTUFBTSxFQUFFLENBQUMsQ0FBQyxLQUFLO0NBQ2xCLENBQUM7QUFDVyxRQUFBLGNBQWMsR0FBRztJQUMxQixDQUFDLGdCQUFRLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSTtJQUNyQixDQUFDLGdCQUFRLENBQUMsTUFBTSxDQUFDLEVBQUUsSUFBSTtDQUMxQixDQUFDIn0=